import { render, staticRenderFns } from "./elementStaff.vue?vue&type=template&id=aacf145a"
import script from "./elementStaff.vue?vue&type=script&lang=js"
export * from "./elementStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports